export default function() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod/i.test(userAgent)
}
